export const DEV_DOMAIN = "localhost:3000";
// lt - service domain
export const TEST_SERVICE_DOMAIN = "test-service.perlasgo.lt";
export const SANDBOX_SERVICE_DOMAIN = "sandbox-service.perlasgo.lt";
export const STG_SERVICE_DOMAIN = "staging-service.perlasgo.lt";
export const PROD_SERVICE_DOMAIN = "service.perlasgo.lt";

export const WEB_DOMAINS = {
  lt: {
    //lt - perlasgo
    test: "test.perlasgo.lt",
    sandbox: "sandbox.perlasgo.lt",
    stg: "staging-savitarna.perlasgo.lt",
    prod: "savitarna.perlasgo.lt",
  },
  pl: {
    //pl - perlasgo
    test: "pl-test.perlasgo.lt", //todo PL -change to correct one
    sandbox: "pl-sandbox.perlasgo.lt", //todo PL -change to correct one
    stg: "pl-staging.perlasgo.lt", //todo PL -change to correct one
    prod: "pl.perlasgo.lt", //todo PL -change to correct one
  },
};
